"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveLabel = void 0;

var resolveLabel = function resolveLabel(namedTitle, option) {
  var resolveFromOption = function resolveFromOption() {
    if (option.alias) {
      return option.alias;
    }

    if (option.name) {
      return option.name;
    }

    return option.identifier;
  };

  return !!namedTitle ? namedTitle : resolveFromOption();
};

exports.resolveLabel = resolveLabel;